'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_Cuisine(id) {
  this.ik = null;
  this.ik = id;
}
export { $c_Lmealorama_Cuisine as $c_Lmealorama_Cuisine };
$p = $c_Lmealorama_Cuisine.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Cuisine;
/** @constructor */
function $h_Lmealorama_Cuisine() {
}
export { $h_Lmealorama_Cuisine as $h_Lmealorama_Cuisine };
$h_Lmealorama_Cuisine.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 589764451, true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lmealorama_Cuisine) && (this.ik === x$0.ik)));
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 1;
});
$p.r = (function() {
  return "Cuisine";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.ik;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_Cuisine(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.js)));
}
export { $isArrayOf_Lmealorama_Cuisine as $isArrayOf_Lmealorama_Cuisine };
var $d_Lmealorama_Cuisine = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Cuisine, "mealorama.Cuisine", ({
  js: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_Cuisine as $d_Lmealorama_Cuisine };
//# sourceMappingURL=mealorama.-Cuisine.js.map
